import {defineCustomElement, h, getCurrentInstance, createApp, defineAsyncComponent} from 'vue';
import Icon from '@/plugins/icon'
import Directive from '@/plugins/directive'
import PrimeVue from 'primevue/config';
import Menu from "primevue/menu";
import Tooltip from "primevue/tooltip";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import SelectButton from "primevue/selectbutton";
import ToggleButton from "primevue/togglebutton";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import AutoComplete from "primevue/autocomplete";
import Toolbar from "primevue/toolbar";
import OverlayPanel from "primevue/overlaypanel";
import ColorPicker from "primevue/colorpicker";
import Inplace from "primevue/inplace";
import Dialog from "primevue/dialog";
import Menubar from "primevue/menubar";
import Avatar from "primevue/avatar";
import Sidebar from "primevue/sidebar";
import Slider from "primevue/slider";
import {createPinia} from "pinia";
import RadioButton from 'primevue/radiobutton'
import Divider from 'primevue/divider'
import FileUpload from "primevue/fileupload";
import Badge from "primevue/badge";
import Paginator from "primevue/paginator";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Skeleton from "primevue/skeleton";
import ProgressBar from "primevue/progressbar";
import Toast from "primevue/toast";
import Image from "primevue/image";
import TabView from "primevue/tabview"
import TabPanel from "primevue/tabpanel"


const plugins = [PrimeVue, Icon, Directive];
const Canvas = defineAsyncComponent(() =>
    import('./views/Viewer/Canvas/index.vue')
)

const registerComponents = (app: any) => {
    const components = [
        Button,
        InputNumber,
        Dropdown,
        SelectButton,
        ToggleButton,
        InputSwitch,
        InputText,
        InputGroup,
        InputGroupAddon,
        Checkbox,
        Textarea,
        AutoComplete,
        Toolbar,
        OverlayPanel,
        ColorPicker,
        Inplace,
        Dialog,
        Menubar,
        Avatar,
        Sidebar,
        Slider,
        RadioButton,
        Divider,
        FileUpload,
        Badge,
        Paginator,
        Accordion,
        AccordionTab,
        Skeleton,
        ProgressBar,
        Toast,
        Image,
        TabView,
        TabPanel
    ];

    components.forEach((component) => app.component(component.name, component));
}

const getSlideStyle = () => {
    let css = window['templateCss']
    if (!css) {
        return ""
    }

    const start = css.indexOf("/* Start Slide Editor CSS")
    if (start > -1) {
        css = css.substring(start)
    }

    const end = css.indexOf("/* End Slide Editor CSS")
    if (end > -1) {
        css = css.substring(0, end)
    }

    return css
}



export const thumbnailWidget = defineCustomElement({
    props: Canvas.props,
    setup(props) {
        const app = createApp(Canvas);
        const pinia = createPinia()
        registerComponents(app)

        plugins.forEach(plugin => app.use(plugin));
        app.component('PrimeMenu', Menu)

        app.directive('tooltip', Tooltip);
        app.use(pinia)

        const inst = getCurrentInstance();
        if (inst === null) return;
        Object.assign(inst.appContext, app._context);
        Object.assign(inst.appContext.provides, app._context.provides);

        return () => h(Canvas, props)
    },
    styles: [getSlideStyle()]
});
